export default __webpack_public_path__ + "static/media/railway.3fddf371.png";